import { createStyles, makeStyles, Theme } from '@material-ui/core';
import vtkCamera from 'vtk.js/Sources/Rendering/Core/Camera';

import { DualViewPanel } from '../shared/common';
import Canvas from './index';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: '100%',
      width: '100%',
      padding: '0 0 0 10px',

      display: 'grid',
      gridTemplateColumns: '50% 50%',
      gridTemplateRows: '100%',
    },
  })
);

const DualViewCanvas = () => {
  const classes = useStyles();
  const camera = vtkCamera.newInstance();
  return (
    <div className={classes.root}>
      <Canvas id="leftCanvas" background="#f5f5f5" panel={DualViewPanel.Left} syncCamera={camera}></Canvas>
      <Canvas
        id="rightCanvas"
        background="#f5f5f5"
        panel={DualViewPanel.Right}
        syncCamera={camera}
        hideOrientationMarker={true}
      ></Canvas>
    </div>
  );
};

export default DualViewCanvas;
